import { mixpanel } from '@fiverr-private/obs';
import {
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
    MIXPANEL_PAGE_NAMES,
} from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

export const reportPageView = () => {
    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_VIEW, {
        ...getDataFromStores(
            store.brief,
            store.user,
            store.pagePath,
            store.referrer,
            store.sellerId,
            store.projectId,
            store.variationId
        ),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.CHOOSE_VARIATION,
    });
};
